import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal, MaskedLines } from "../components/Reveal";
import { PROJECTS } from "../data/work";
import { SERVICES } from "../data/services";
import { IMG, imgProps } from "../data/assets";

// SCENE 11: asymmetric editorial project grid with hover meta reveals.
export function WorkScene() {
  const [a, b, c] = PROJECTS;
  return (
    <section className="bg-offwhite py-16 md:py-24" aria-label="Selected project stories">
      <div className="container-x">
        <Reveal>
          <p className="eyebrow">08 / Our Work</p>
        </Reveal>
        <div className="flex flex-wrap items-end justify-between gap-6">
          <MaskedLines
            as="h2"
            lines={["STORIES TOLD IN", "EVIDENCE."]}
            accent={[1]}
            accentTone="text-dcc-strong"
            className="h-display mt-6 text-4xl text-charcoal sm:text-5xl lg:text-6xl"
          />
          <Reveal delay={0.1}>
            <Link to="/our-work" data-testid="work-all-link" className="link-tech text-charcoal">All project stories <span aria-hidden="true">→</span></Link>
          </Reveal>
        </div>

        <div className="mt-10 grid gap-6 lg:grid-cols-12">
          <Reveal className="lg:col-span-7">
            <WorkCard p={a} big />
          </Reveal>
          <div className="grid gap-6 lg:col-span-5">
            <Reveal delay={0.08}><WorkCard p={b} /></Reveal>
            <Reveal delay={0.16}><WorkCard p={c} /></Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}

function WorkCard({ p, big = false }) {
  const service = SERVICES.find((s) => s.id === p.service);
  return (
    <Link to={`/our-work/${p.id}`} data-testid={`work-card-${p.id}`} data-cursor="VIEW" className="group relative block overflow-hidden border border-zinc-200">
      <img
        src={IMG[p.image].src}
        alt={IMG[p.image].alt}
        {...imgProps(IMG[p.image].src)}
        loading="lazy"
        className={`w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105 ${big ? "aspect-[16/10]" : "aspect-[16/8]"}`}
      />
      <div className="absolute inset-0 flex flex-col justify-end bg-charcoal/0 p-6 transition-colors duration-500 group-hover:bg-charcoal/70 md:p-8">
        <div className="translate-y-4 opacity-0 transition-all duration-500 group-hover:translate-y-0 group-hover:opacity-100">
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-dcc-strong">
            {p.industry} · {p.region} · {service?.name.replace("Commercial ", "")}
          </p>
          <h3 className="mt-2 max-w-lg font-display text-xl font-semibold uppercase leading-tight tracking-tight text-zinc-50 md:text-2xl">
            {p.title}
          </h3>
          <p className="mt-3 flex items-center gap-2 font-mono text-xs uppercase tracking-[0.25em] text-zinc-300">
            Evidence: imagery + checklist + certificate <ArrowUpRight size={13} aria-hidden="true" />
          </p>
        </div>
      </div>
      <span className="absolute left-0 top-0 bg-white px-3 py-1.5 font-mono text-xs uppercase tracking-[0.25em] text-charcoal">
        {p.region}
      </span>
    </Link>
  );
}
